(() => {
  if (window.MayLondonGoogle) return;
  const config = JSON.parse(document.getElementById('MayLondonConfig')?.textContent || '{}');
  const id = String(config.googleTagId || '').trim();
  const denied = { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' };
  let started = false, granted = false, pageSent = false;
  const eligible = () => config.analyticsMode === 'google' && /^G-[A-Z0-9]{6,20}$/.test(id)
    && location.protocol === 'https:' && ['may-london.com', 'www.may-london.com'].includes(location.hostname)
    && !window.Shopify?.designMode && !window.Shopify?.previewMode
    && !new URLSearchParams(location.search).has('preview_theme_id')
    && !document.getElementById('ShopifyPreviewBar')
    && !/\/(?:account|checkouts?|orders)(?:\/|$)/.test(location.pathname);
  const consent = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.analyticsProcessingAllowed?.() === true && privacy?.currentVisitorConsent?.().analytics === 'yes';
    } catch (_) { return false; }
  };
  const externalTag = () => typeof window.gtag === 'function' || Boolean(window.google_tag_manager)
    || [...document.scripts].some(script => {
      try { const url = new URL(script.src); return /(^|\.)googletagmanager\.com$/.test(url.hostname) && /\/(gtag\/js|gtm\.js)$/.test(url.pathname); }
      catch (_) { return false; }
    }) || (window.dataLayer || []).some(entry => entry?.[0] === 'config' || entry?.event === 'gtm.js');
  const command = function() { window.dataLayer.push(arguments); };
  const page = () => ({ page_location: location.origin + location.pathname, page_referrer: '', page_title: 'May-London' });
  function refresh() {
    const next = eligible() && consent();
    if (!next) {
      if (started) {
        window['ga-disable-' + id] = true;
        if (granted) command('consent', 'update', denied);
      }
      granted = false;
      return false;
    }
    if (!started) {
      // An existing app/GTM owns its tag and consent. Do not create a second sender.
      if (externalTag()) return false;
      window.dataLayer = window.dataLayer || [];
      window.gtag = command;
      started = true;
      command('consent', 'default', denied);
      command('js', new Date());
    }
    window['ga-disable-' + id] = false;
    if (!granted) command('consent', 'update', { ...denied, analytics_storage: 'granted' });
    granted = true;
    if (!pageSent) {
      command('config', id, { ...page(), send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false });
      command('event', 'page_view', { ...page(), send_to: id });
      pageSent = true;
      const script = document.createElement('script');
      script.async = true;
      script.dataset.mayLondonGoogle = id;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
      document.head.appendChild(script);
    }
    return true;
  }
  function send(payload) {
    if (!refresh()) return false;
    const data = { ...page(), send_to: id, event_id: payload.event_id };
    if (payload.ecommerce) Object.assign(data, payload.ecommerce);
    if (payload.item_list_name) data.item_list_name = payload.item_list_name;
    // Count searches without transmitting customers' free-text queries.
    command('event', payload.event, data);
    return true;
  }
  window.MayLondonGoogle = { refresh, send };
})();
